<template>
    <div class="rounded-32 bg-primary-20">
        <div class="block h-full rounded-32" :class="ratingColor" :style="{width: (this.score || 0) + '%'}"></div>
    </div>
</template>

<script>
export default {
    props: {
        count: null,
        score: {
            required: true,
            validator: value => typeof value === 'number' || value === null,
        }
    },
    computed: {
        ratingColor() {
            const ratings = {
                0: 'bg-primary-20',
                20: 'bg-semantic-error-dark',
                40: 'bg-semantic-error',
                60: 'bg-semantic-warning',
                80: 'bg-semantic-success',
                100: 'bg-semantic-success-dark',
            };

            if (this.score === null) {
                return ratings[0];
            }

            const score = Math.ceil(Math.max(1, this.score / 20)) * 20;

            return ratings[score];
        }
    },
}
</script>
